import React from "react";
import AppConstants from "../../constants/AppConstants";
import StyleUtils from "../../utils/StyleUtils";
import DesignContextUtils from "../../utils/DesignContextUtils";
import { DESIGN_CONTEXT, ASSET_URL_OP_FILE } from "../../constants/DesignContextConstants";
import { BLUR } from "../../constants/MergeConstants";

const { RESOURCE_ASSET } = AppConstants;

const SVG = ({ content, elemProps, theme }) => {
  const styleDefaults = {
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    pointerEvents: "none",
  };

  const shadowStyle = StyleUtils.getShadowStyle(elemProps, theme, "svg");

  const blur = Number(elemProps.getIn(BLUR.split("."), 0) ?? 0);
  let style = { ...styleDefaults, ...shadowStyle };

  if (blur > 0) {
    const existingFilter = style.filter || "";
    style.filter = existingFilter ? `${existingFilter} blur(${blur}px)` : `blur(${blur}px)`;
  }

  const contentType = content.get("type", "unknown");
  const key = content.get("key");
  const designContext = elemProps.get(DESIGN_CONTEXT);
  const { generateDesignAssetUrl } = DesignContextUtils.fromContext(designContext);
  const src = generateDesignAssetUrl({ op: ASSET_URL_OP_FILE, key, elemProps, content });

  return contentType === RESOURCE_ASSET ? (
    <img style={style} src={src} alt="" draggable={false} />
  ) : (
    <div style={style}></div>
  );
};

export default SVG;
